/* eslint-disable react/react-in-jsx-scope */
import { GENDERS } from '../../../constants/models'
import FormDatePicker from '../elements/FormDatePicker'
import FormSelectInput from '../elements/FormSelectInput'
import FormTextInput from '../elements/FormTextInput'
import { participantInfoDisplayFields } from '../utils/participantInfoFields'

const IndividualUserFormContent = ({ values, formDisabled }) => [
  {
    id: 'participant-more-info-form-details',
    name: 'Participant Details',
    inputs: [
      ...participantInfoDisplayFields(values),
      {
        id: 'birthdate',
        size: { sm: 12, md: 6 },
        field: (
          <FormDatePicker
            name="birthdate"
            label="Birthdate"
            required
            autoComplete="new-birthdate"
            placeholder="YYYY-MM-DD"
            disabled={formDisabled}
          />
        ),
      },
      {
        id: 'gender',
        size: { sm: 12, md: 6 },
        field: (
          <FormSelectInput
            name="gender"
            label="Gender"
            autoComplete="new-gender"
            placeholder="Select Gender"
            disabled={formDisabled}
            options={Object.entries(GENDERS).map(([key, value]) => ({
              value: key,
              text: value,
            }))}
            required
          />
        ),
      },
      {
        id: 'address',
        size: 12,
        field: (
          <FormTextInput
            name="address"
            label="Home Address"
            required
            autoComplete="new-address"
            disabled={formDisabled}
          />
        ),
      },
    ],
  },
]
export default IndividualUserFormContent
